export class TTTFollowUpModel{
  tttplanid = '' ;
  tttplanname = '' ;
  pacode = '' ;
  paname = '';
  tttnoofcycle = '' ;
  tttdate ='2022-01-01';
  cbchb = '' ;
  cbctlc = '' ;
  cbcpnl = '';
  cbcplat = '' ;
  protocol = '' ;
  protocolName = '';
  tttdose = 0 ;
  tttunit = '' ;
  unitname ='';
  tttrote = '' ;
  tttday = '' ;
  tttcycleno = '' ;
  tttnextcycle = '2022-01-01';
  doctor = '' ;
  docname = '';
  tttnotes = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = '2022-01-01';


}
